<div *ngIf="isLoading | async" class="overlay">
  <!-- <img src="../../../../assets/imgs/4bb5i2.svg" class="spinner" alt=""> -->

 <h1 class="spinner">
  <span class="loader"></span> &nbsp; {{'loading' | translate}}

  </h1>
</div>
